import { useLocation } from 'react-router-dom';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@immo/ui-kit';
import { useTranslations } from '@/i18n/use-translations';

export function AccessDeniedPage() {
  const t = useTranslations('pages.admin.access-denied');
  const { state } = useLocation();
  // Two refusals share this page: the admission gate (not platform staff at
  // all) and a route the operator holds no permission for. Telling the second
  // group they don't belong in the admin app sends them chasing the wrong fix.
  const missingPermission = (state as { reason?: string } | null)?.reason === 'missing-permission';

  return (
    <main className="flex min-h-screen items-center justify-center bg-canvas p-6">
      <Card className="w-full max-w-md">
        <CardHeader>
          <CardTitle>{t('title')}</CardTitle>
          <CardDescription>{t(missingPermission ? 'body-missing-permission' : 'body')}</CardDescription>
        </CardHeader>
        <CardContent>
          <a
            href="/sign-in"
            className="block text-center text-base text-interactive underline-offset-4 hover:underline"
          >
            {t('back-to-sign-in')}
          </a>
        </CardContent>
      </Card>
    </main>
  );
}
